import {InjectionToken, NgModule} from "@angular/core";
import {ChromeExtensionProxy} from "./chrome.communication/chrome.extension.proxy";


export let CHROME_EXTENSION_ID = new InjectionToken<string>('chrome extension id');

@NgModule({
})
export class BrowserCommunicationModule{

	public static forRoot(){
		return {
			ngModule:BrowserCommunicationModule,
			providers:[
				ChromeExtensionProxy,
				{provide:CHROME_EXTENSION_ID ,useValue:"cbgkapdnbipkilpjladpocfdapfdacal"}
			]
		};
	}
}
